export const ProfileType = {
  CompanyName: 'companyNameTargets',
  Industry: 'industry',
  JobFunction: 'jobTargets',
};
